/**
 * Remember last successful login identity in localStorage (no password).
 * Username is used to prefill the login form; userId is kept for a future BE flow.
 */

export const LAST_LOGIN_IDENTITY_STORAGE_KEY = "lastLoginIdentity";

/**
 * @returns {{ userId: string, username: string } | null}
 */
export function readLastLoginIdentity() {
  try {
    const raw = localStorage.getItem(LAST_LOGIN_IDENTITY_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    const username =
      typeof parsed?.username === "string" ? parsed.username.trim() : "";
    const userId =
      typeof parsed?.userId === "string"
        ? parsed.userId.trim()
        : parsed?.userId != null
          ? String(parsed.userId).trim()
          : "";
    if (!username && !userId) return null;
    return { userId, username };
  } catch {
    return null;
  }
}

/**
 * @param {{ userId?: string | null, username?: string | null }} identity
 */
export function writeLastLoginIdentity({ userId, username } = {}) {
  const nextUsername =
    typeof username === "string" ? username.trim() : username != null ? String(username).trim() : "";
  const nextUserId =
    typeof userId === "string"
      ? userId.trim()
      : userId != null
        ? String(userId).trim()
        : "";

  if (!nextUsername && !nextUserId) return;

  try {
    const existing = readLastLoginIdentity() || { userId: "", username: "" };
    localStorage.setItem(
      LAST_LOGIN_IDENTITY_STORAGE_KEY,
      JSON.stringify({
        userId: nextUserId || existing.userId || "",
        username: nextUsername || existing.username || "",
      }),
    );
  } catch {
    // Ignore storage write failures.
  }
}

/** Username only — for login form prefill. */
export function readLastLoginUsername() {
  return readLastLoginIdentity()?.username || "";
}
